import fp from 'lodash/fp';
import get from 'lodash/get';
import ProfessionalLink from '../subunit-content/ProfessionalLink';
import SignedLink from '../subunit-content/SignedLink';
import WorldLanguagePilotLink from '../subunit-content/WorldLanguagePilotLink';
import { JSTOR_RESOURCE_DOMAIN, ResourceContentTypes } from './constants';

export const isCollapsedSubunit = ({
  subjectId,
  userId,
  unitNumber,
  subunits,
  visitedSubunits,
}) => {
  const currentVisitedSubunits = get(
    visitedSubunits,
    [`${subjectId}-${userId}`, unitNumber],
    {},
  );
  const subunitsWithResources = subunits.filter(
    ({ resources }) => resources.length > 0,
  );
  return subunitsWithResources.some(
    ({ number, subunitId }) => !currentVisitedSubunits[number || subunitId],
  );
};

export const mapAssignmentsToResourceIds = (
  teacherAssignments = {},
  resources = [],
) => {
  const { assignments } = teacherAssignments || {};
  if (assignments && resources.length) {
    const resourcesAssessmentIds = resources.map(
      (resource) => resource.assessmentId,
    );
    const mappedAssignments =
      assignments &&
      assignments.filter((assignment) =>
        resourcesAssessmentIds.includes(assignment.assessment.itemId),
      );
    return mappedAssignments;
  }
  return [];
};

export const isResourceWithJstorLink = (url) =>
  (url || '').includes(JSTOR_RESOURCE_DOMAIN);

export const getLinkComponentByType = (contentType) => {
  const matchComponent = fp.cond([
    [
      fp.isEqual(ResourceContentTypes.PROFESSIONAL_LINK),
      fp.constant(ProfessionalLink),
    ],
    // Any World Language Practice activity will have this prefix
    [fp.startsWith('WL_'), fp.constant(WorldLanguagePilotLink)],
    [fp.stubTrue, fp.constant(SignedLink)],
  ]);

  return matchComponent(contentType);
};
